import axiosInstance from "./AxiosInstance";

export const submitAnswer = async (payload) => {
  try {
    const response = await axiosInstance.post("api/contact", payload);
    return response; 
  } catch (error) {
    console.error("Error in submitting form:", error);
    throw error;
  }
};
